import { LucideIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface StatCardProps {
  icon: LucideIcon;
  label: string;
  value: number;
  navigateTo?: string;
  subLabel?: string;
}

const StatCard = ({ icon: Icon, label, value, navigateTo, subLabel }: StatCardProps) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (navigateTo) {
      navigate(navigateTo);
    }
  };

  // Determine navigation based on label if not explicitly provided
  const getDefaultNavigation = () => {
    switch (label) {
      case "Employees":
        return "/settings/team";
      case "Today's Treatments":
        return "/aesthetics/treatments?tab=upcoming";
      case "Total Clients":
        return "/aesthetics/clients";
      case "This Month":
        return "/aesthetics/treatments";
      default:
        return undefined;
    }
  };

  const targetNav = navigateTo || getDefaultNavigation();

  return (
    <div 
      className={`flex items-center gap-4 bg-card rounded-2xl px-6 py-7 shadow-md bg-white transition-all duration-200 ${
        targetNav ? 'cursor-pointer hover:shadow-lg hover:scale-[1.02]' : ''
      }`}
      onClick={handleClick}
    >
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-secondary flex items-center justify-center bg-purple-100">
          <Icon className="w-5 h-5 text-[#704AAF]" />
        </div>
        <div className="flex flex-col">
          <span className="text-foreground font-medium">{label}</span>
          {subLabel && (
            <span className="text-xs text-muted-foreground">{subLabel}</span>
          )}
        </div>
      </div>
      <div className={`ms-auto bg-purple-100 text-[#704AAF] px-4 py-1.5 font-semibold text-lg text-center rounded-[50rem] ${
        String(value).length > 2 ? "bg-transparent text-xl" : ""
      }`}>
        {value}
      </div>
    </div>
  );
};

export default StatCard;
